// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field {
  display: flex;
  flex-direction: column;
}

form {
  margin-bottom: 2rem;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 1rem;
  margin-bottom: 2rem;
}

.groups-field {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.groups-field .group-field {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(18rem, auto));
  gap: 1rem;
}
.groups-field button {
  margin-top: 1rem;
  width: -moz-fit-content;
  width: fit-content;
}

.translations {
  margin: 2rem 0;
}

p-footer {
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
  margin-top: 2rem;
}

.btTop {
  text-align: right;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.btTop > * {
  margin-left: 1rem;
}

.flex-container {
  display: flex;
  height: 100%;
  gap: 20px;
}
.flex-container .item1 {
  flex-grow: 0;
}
.flex-container .item2 {
  flex-grow: 1;
}

.custom-marker {
  display: flex;
  width: 2rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  border-radius: 50%;
  z-index: 1;
}

::ng-deep .p-timeline-event-content,
::ng-deep .p-timeline-event-opposite {
  line-height: 1;
}

@media screen and (max-width: 960px) {
  ::ng-deep .customized-timeline .p-timeline-event:nth-child(even) {
    flex-direction: row !important;
  }
  ::ng-deep .customized-timeline .p-timeline-event:nth-child(even) .p-timeline-event-content {
    text-align: left !important;
  }
  ::ng-deep .customized-timeline .p-timeline-event-opposite {
    flex: 0;
  }
  ::ng-deep .customized-timeline .p-card {
    margin-top: 1rem;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/workflow-old/edit/workflow-edit-old.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AACI;EACI,aAAA;EACA,6DAAA;EACA,SAAA;AACR;AAEI;EACI,gBAAA;EACA,uBAAA;EAAA,kBAAA;AAAR;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,aAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAEI;EACI,iBAAA;AAAR;;AAGA;EACI,aAAA;EACA,YAAA;EACA,SAAA;AAAJ;AAEI;EACI,YAAA;AAAR;AAGI;EACI,YAAA;AADR;;AAOA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAJJ;;AAQI;;EAEI,cAAA;AALR;;AASA;EAGY;IACI,8BAAA;EARd;EAUc;IACI,2BAAA;EARlB;EAYU;IACI,OAAA;EAVd;EAaU;IACI,gBAAA;EAXd;AACF;AAEA,ogHAAogH","sourcesContent":[".field {\n    display: flex;\n    flex-direction: column;\n}\n\nform {\n    margin-bottom: 2rem;\n}\n\n.actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.groups-field {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n\n    .group-field {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(18rem, auto));\n        gap: 1rem;\n    }\n\n    button {\n        margin-top: 1rem;\n        width: fit-content;\n    }\n}\n\n.translations {\n    margin: 2rem 0;\n}\n\np-footer {\n    display: flex;\n    flex-direction: row-reverse;\n    gap: 1rem;\n    margin-top: 2rem;\n}\n\n.btTop {\n    text-align: right;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n    > * {\n        margin-left: 1rem;\n    }\n}\n.flex-container {\n    display: flex;\n    height: 100%;\n    gap: 20px;\n\n    .item1 {\n        flex-grow:0;\n    }\n\n    .item2 {\n        flex-grow:1;\n    }\n}\n\n\n\n.custom-marker {\n    display: flex;\n    width: 2rem;\n    height: 2rem;\n    align-items: center;\n    justify-content: center;\n    color: #ffffff;\n    border-radius: 50%;\n    z-index: 1;\n}\n\n::ng-deep {\n    .p-timeline-event-content,\n    .p-timeline-event-opposite {\n        line-height: 1;\n    }\n}\n\n@media screen and (max-width: 960px) {\n    ::ng-deep {\n        .customized-timeline {\n            .p-timeline-event:nth-child(even) {\n                flex-direction: row !important;\n\n                .p-timeline-event-content {\n                    text-align: left !important;\n                }\n            }\n\n            .p-timeline-event-opposite {\n                flex: 0;\n            }\n\n            .p-card {\n                margin-top: 1rem;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
